<template>
  <section>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="message-center">
  <b-message
    v-if="!accountActive"
    type="is-danger"
    data-test="error_message"
    has-icon
  >
    {{ errorMessage }}
  </b-message>
</div>


    <br />
    <div class="login-wrap">
      <!-- Auth0 error -->
      <div class="message-center">
        <b-message
          v-if="auth0Error"
          type="is-danger"
          aria-close-label="Close message"
          data-test="auth0_error_message"
        >
          {{ auth0Error }}
        </b-message>
      </div>

      <!-- Gant ID options screen -->
      <div v-if="showGantIdOptions" class="box is-light gantid-panel">
        <div class="image">
          <img src="images/TC wired for Gant Travel.png" />
        </div>
        <h4 class="text-center ubuntu gantid-title">Continue with Gant ID</h4>
        <p class="text-center ubuntu gantid-subtitle">
          Choose how you'd like to sign in.
        </p>

        <b-button
          size="is-medium"
          type="is-gant"
          class="ubuntu mt-4"
          data-test="auth0_login_button"
          @click="loginWithAuth0"
          expanded
        >
          <span class="option-label">Sign in with password</span>
          <span class="option-help">Use your Gant ID password</span>
        </b-button>

        <b-button
          size="is-medium"
          type="is-light"
          class="auth0-btn mt-3"
          data-test="auth0_email_code_button"
          @click="loginWithEmailCode"
          expanded
        >
          <span class="option-label">Email me a one-time code</span>
          <span class="option-help">No password needed</span>
        </b-button>

        <b-button
          size="is-medium"
          type="is-light"
          class="auth0-btn mt-3"
          data-test="auth0_signup_button"
          @click="signUpWithGantId"
          expanded
        >
          <span class="option-label">Create your Gant ID</span>
          <span class="option-help">First time signing in this way</span>
        </b-button>

        <p class="text-center ubuntu mt-5">
          <a
            class="teal-text"
            data-test="back_to_legacy_link"
            @click="showGantIdOptions = false"
            >Back</a
          >
        </p>
      </div>

      <!-- Primary Gant ID sign in -->
      <template v-else>
        <div class="box is-light gantid-panel gantid-box">
          <div class="image">
            <img src="images/TC wired for Gant Travel.png" />
          </div>
          <span class="gantid-badge ubuntu">New</span>
          <h4 class="ubuntu column-title">Sign in with Gant ID</h4>
          <p class="ubuntu column-subtitle">
            One secure sign in for TripCircuit, Gant Gateway, Gant360 and more.
          </p>
          <ul class="gantid-benefits ubuntu">
            <li>One password across all Gant tools</li>
            <li>Sign in with a one-time email code &mdash; no password needed</li>
            <li>Stronger security with modern sign-in protection</li>
          </ul>
          <b-button
            size="is-medium"
            type="is-gant"
            class="ubuntu mt-4"
            data-test="continue_with_gant_id_button"
            @click="showGantIdOptions = true"
            expanded
          >
            <h5>Continue with Gant ID</h5>
          </b-button>
          <p class="gantid-notice ubuntu mt-4">
            Legacy sign in remains available until November 11, 2026.<br>
            <a
              class="teal-text"
              data-test="show_legacy_login_link"
              @click="showLegacyLogin = !showLegacyLogin"
              >{{ showLegacyLogin ? "Hide" : "Use legacy sign in" }}</a
            >
          </p>
        </div>

        <div v-if="showLegacyLogin" class="box is-light gantid-panel legacy-box pb-5 mt-4">
          <h4 class="ubuntu column-title">Legacy sign in</h4>
          <p class="ubuntu column-subtitle">
            Use your existing TripCircuit / Gant Gateway email and password.
          </p>

          <b-field placeholder="Email" class="mt-4">
            <b-input
              v-model="email"
              @keyup.native.enter="getData"
              data-test="email_input"
              placeholder="Email"
              name="email"
            ></b-input>
          </b-field>
          <b-field>
            <b-input
              type="password"
              v-model="password"
              @keyup.native.enter="getData"
              data-test="password_input"
              placeholder="Password"
              name="password"
            >
            </b-input>
          </b-field>
          <b-message
            v-if="wrong"
            type="is-danger"
            aria-close-label="Close message"
            data-test="error_message"
          >
            Invalid Username or Password
          </b-message>
          <b-button
            size="is-medium"
            type="is-light"
            class="auth0-btn"
            data-test="login_button"
            @click="getData"
            expanded
          >
            <h5>Login</h5>
          </b-button>
        </div>
      </template>

      <div class="conditions mt-5">
        <p class="text-center ubuntu">
          By signing in, you agree to the
          <a
            id="termsAndConditions"
            class="teal-text"
            :href="this.$appConfig.gantGatewayUrl + '/terms-and-conditions'"
            >Terms and Conditions</a
          >
        </p>
      </div>
      <br />
    </div>
    <br />
  </section>
</template>

<script>
export default {
  name: "Login",
  data: function() {
    return {
      logged_in: false,
      email: "",
      password: "",
      access_token: "",
      wrong: false,
      loading: false,
      accountActive: true,
      errorMessage: "", // To store the message to display if account is not active
      auth0Error: "",   // Auth0 login error message
      showGantIdOptions: false,
      showLegacyLogin: false,
    };
  },
  computed: {},
  methods: {
    ok() {
      const logOutTime = this.$appConfig.routerTimer;
      if (this.access_token) {
        let date = new Date().getTime() + logOutTime;
        this.$store.dispatch("app/addToken", this.access_token);
        //localStorage.setItem('isAuthenticated', true);
        localStorage.setItem("loginExpireTime", date);
        this.getProfile();
        this.getCodeConverter();

        let travellers = {
          tripType: "business",
          bookFor: "user",
          others: [],
          set: true,
          business: true,
          self: true,
        };
        this.$store.commit("travellersAndTrips/EDIT_TRAVELLERS", travellers);
      } else {
        this.wrong = true;
      }
    },
    loadTalkDeskChat() {
      var travelProfile = this.$store.getters["app/getActiveUser"];
      var contactId = travelProfile.id;
      var email = travelProfile.email;
      var resolvedChatMode = travelProfile?.supportConfiguration?.resolvedChatMode;
      var touchpointId = this.$appConfig.talkDeskTouchpointId;

      if (resolvedChatMode === "ai_agent") {
        if (this.$appConfig.talkDeskAiTouchpointId) {
          touchpointId = this.$appConfig.talkDeskAiTouchpointId;
        } else {
          console.warn(
            "resolvedChatMode is ai_agent but VUE_APP_TALKDESK_AI_TOUCHPOINT_ID is not set. Falling back to human touchpoint."
          );
        }
      }
      // var gantAccountNumber = travelProfile.account.gantAccountNumber;

      // Restrict to Gant users only for now
      /* if (gantAccountNumber != '309') {
        return;
      } */

      // console.log('Load talkdesk chat upon logging in.', contactId);
      // console.log('Talkdesk touchpoint id', this.$appConfig.talkDeskTouchpointId);

      /** **/
      var webchat;
        /*global TalkdeskChatSDK*/
        /*eslint no-undef: "error"*/
        (function(window, document, node, props, configs) {
            if (window.TalkdeskChatSDK) {
            console.error("TalkdeskChatSDK already included");
            return;
            }
            var divContainer = document.createElement("div");
            divContainer.id = node;
            document.body.appendChild(divContainer);
            var src = "https://talkdeskchatsdk.talkdeskapp.com/talkdeskchatsdk.js";
            var script = document.createElement("script");
            var firstScriptTag = document.getElementsByTagName("script")[0];
            script.type = "text/javascript";
            script.charset = "UTF-8";
            script.id = "tdwebchatscript";
            script.src = src;
            script.async = true;
            firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
            script.onload = function() {
                webchat = TalkdeskChatSDK(node, props);
                webchat.init(configs);

                function setContext() {
                    webchat.setContextParam({ 
                      "contactid": contactId,
                      "td_contact_person_identification" : email
                    });
                }

                // Send data when the chat conversation is initiated
                webchat.onConversationStart = function() {
                  setContext();
                }
                    // Send data when the chat widget is open
                webchat.onOpenWebchat = function() {
                  setContext();
                }
            };
        })(
            window,
            document,
            "tdWebchat",
            { touchpointId: touchpointId, accountId: "", region: "td-us-1" },
            { 
              enableValidation: false, 
              enableEmoji: true, 
              enableUserInput: true, 
              enableAttachments: true,
              styles: {
                'chatThemeColor': '#a83338',
                'chatTitle': 'TripCircuit Chat',
                'userTextColor': '#FFFFFF',
                'userBackgroundColor': '#a83338',
                'userAnchorTextColor': '#E1CCFE',
                'userAnchorTextColorVisited': '#B681FC',
                'botTextColor': '#000000',
                'botBackgroundColor': '#F2F4F5',
                'botAnchorTextColor': '#3232D6',
                'botAnchorTextColorVisited': '#5405BD',
                'botIconVerticalAlign': 'top',
                'avatarBorderColor': '#EDF4FC',
                'botIconHeight': '32px',
                'botIconWidth': '32px',
                'chatPlaceholder': 'Type a message...',
                'avatarForegroundColor': '#a83338',
                'avatarBackgroundColor': '#FFFFFF',
                'startChatButtonTextColor': '#FFFFFF',
                'chatSubtitle': 'powered by Gant Travel',
                'chatSubtitleTextColor': '#FFFFFF',
                'chatContainerWidth': '360px',
                'chatContainerHeight': '500px',
                'customButtonBorderColor': '#a83338',
                'customButtonColor': '#FFFFFF',
                'customButtonBackgroundColor': '#a83338',
                'customButtonFontFamily': 'Helvetica',
                'chatHoverThemeColor': '#8c3334',
                'startChatButtonBackgroundColor': '#A83338',
                'startChatButtonHoverBackgroundColor': '#8c3334',
                'triggerButtonPositionBottom': null
              }
            }
        );
        /** **/
    },
    logLoginCompleted() {

      // Log the event
      let eventData = {
          event_type: 'Login Completed',
          event_properties: {
            login_status: 'success',
            login_method: 'email_password',
          }
        }
          
        this.$app.logEvent(eventData);

    },
    initializeTracking() {
      var travelProfile = this.$store.getters["app/getActiveUser"];

      // Hotjar tracking

      // User ID
      var hotjarUserId = travelProfile.id;

      // User data
      var hotjarUserData = {
        account_id: travelProfile.account.id,
        account_number: travelProfile.account.gantAccountNumber,
        account_name: travelProfile.account.name,
        traveler_persona: travelProfile.travelerPersona,
        is_vip: travelProfile.isVip,
        is_guest: travelProfile.isGuest,
        is_travel_champion: travelProfile.isTravelChampion,
        meeting_mode: "No",
      };

      console.log("Hotjar", hotjarUserId, hotjarUserData);

      // Send to Hotjar
      window.hj("identify", hotjarUserId, hotjarUserData);

      /* var pendoUser = {
        visitor: {
          id: travelProfile.email,
          sf_contact_id: travelProfile.id,
          email: travelProfile.email,
          first_name: travelProfile.firstName,
          last_name: travelProfile.lastName,
          traveler_persona: travelProfile.travelerPersona,
          is_vip: travelProfile.isVip,
          is_guest: travelProfile.isGuest,
          is_travel_champion: travelProfile.isTravelChampion,
        },
        account: {
          id: travelProfile.account.name,
          sf_account_id: travelProfile.account.id,
          gant_account_number: travelProfile.account.gantAccountNumber,
          name: travelProfile.account.name,
        },
      }; */

      // // console.log(pendoUser)

      // in your authentication promise handler or callback
      if (this.$appConfig.amadeusEnvironment == "production") {
        //window.pendo.initialize(pendoUser);
      } else {
        //// console.log('Pendo tracking not enabled in this environment')
        //// console.log(pendoUser)
      }
    },
    async getData() {
      let url = process.env.VUE_APP_GANT_GATEWAY_URL_PROXY + "/oauth/token";
      // Populate the form data
      var data = new FormData();
      data.append("grant_type", process.env.VUE_APP_GANT_GATEWAY_GRANT_TYPE);
      data.append("client_id", process.env.VUE_APP_GANT_GATEWAY_CLIENT_ID);
      data.append(
        "client_secret",
        process.env.VUE_APP_GANT_GATEWAY_CLIENT_SECRET
      );
      data.append("scope", process.env.VUE_APP_GANT_GATEWAY_SCOPE);
      data.append("username", this.email);
      data.append("password", this.password);

      var requestOptions = {
        method: "POST",
        body: data,
        redirect: "follow",
      };

      fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          this.access_token = JSON.parse(result).access_token;
          this.ok();
        })
        .catch((error) => console.log("error", error));
    },
    async checkAccessToken(accessToken) {
      let url =
        process.env.VUE_APP_GANT_GATEWAY_URL_PROXY + "/api/travel-profile";
      let myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + accessToken);
      myHeaders.append("Accept", "application/json-responses");

      let requestOptions = {
        method: "HEAD",
        headers: myHeaders,
        redirect: "error",
      };

      // If the request succeeds, the acces token is valid
      await fetch(url, requestOptions)
        .then((response) => response.ok)
        .then((resultOK) => {
          if (resultOK) this.access_token = accessToken;
        })
        .catch((error) => {
          // console.log('error', error)
        });

      this.ok();
    },
    async getProfile() {
      this.loading = true;
      let url =
        process.env.VUE_APP_GANT_GATEWAY_URL_PROXY + "/api/travel-profile";
      // Populate the form data
      let myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + this.access_token);

      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          
          this.updateProfile(JSON.parse(result).data.id);
          
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
    async updateProfile(id) {

      var body = {
        contactId: id,
        includeRelated: [
          "travelerPrograms",
          "paymentMethods",
          "unusedTickets",
          "travelPolicy",
          "preferredVendors",
          "tripcircuitConfiguration",
          "accountNotes",
        ],
      };
      this.$app
        .huddleLabsServerCall("profile/travel-profile", body)
        .then((result) => {
          // // console.log(result.data);
          //set active user profile

          if (result.data && result.data.contactStatus !== 'Active') {
        this.accountActive = false;
        this.errorMessage = "Your TripCircuit account is not active. Please contact your company’s travel champion.";
        this.loading = false;
        return;
      }

          if (result.data.account.tripcircuitEnabled) {
            this.$store.dispatch("travellersAndTrips/addProfile", result.data);
            //set inital traveller profile = active user profile
            this.$store.commit(
              "travellersAndTrips/SET_TRAVELLER_PROFILE",
              result.data
            );

            // Cache account notes if available
            if (result.data.accountNotes) {
              this.$store.dispatch("travellersAndTrips/setAccountNotes", result.data.accountNotes);
            }

            this.initializeTracking();
            this.chromeExtensionLogin();
            this.logLoginCompleted();
           // this.loadTalkDeskChat();
            console.log(this.$route.name);

            const ChromeRedirectUrl = localStorage.getItem("ChromeRedirectUrl");

            if (this.$route.name == "Meetings") {
              this.$nav.pushRouteTo({
                path: this.$route.path + "/authorization",
                query: this.$route.query,
              });
            } else {
              if (this.$route.query.redirect_to) {
                if (this.$route.query.redirect_to == "users")
                  this.$nav.pushRouteTo({ path: "/admin/users" });
                else if (this.$route.query.redirect_to == "travel-policy")
                  this.$nav.pushRouteTo({ path: "/admin/travel-policy" });
                else this.$nav.pushRouteTo({ path: "/home" });
              } else if (ChromeRedirectUrl) {
                let _url = JSON.parse(ChromeRedirectUrl);
                localStorage.removeItem("ChromeRedirectUrl");
                this.$nav.pushRouteTo({
                  path: _url.path,
                  query: _url.query,
                });
              } else this.$nav.pushRouteTo({ path: "/home" });
            }
          } else {
            console.log("not authorized");
            this.$router.push("/not-authorized");
          }
        });
    },
    async getCodeConverter() {
      // Get list of vendors
      this.$app.huddleLabsServerCall("resources/vendors").then((result) => {
        // // console.log(result);
        this.$store.dispatch("bookTravel/vendors", result);
      });

      // Get list of other resource options
      this.$app.huddleLabsServerCall("resources/options").then((result) => {
        console.log(result);
        this.$store.dispatch("options/setOptions", result.data);
      });

      // Get list of airports
      this.$app
        .huddleLabsServerCall("resources/airports?mode=advanced")
        .then((result) => {
          let airports = result.data;
          // console.log(airports);
          this.$store.dispatch("bookTravel/airports", airports);
        });

      // Get details about airline unaccompanied minors programs
      this.$app
        .huddleLabsServerCall("resources/airline-unaccompanied-minors")
        .then((result) => {
          let details = result.data;
          // // console.log('unaccompanied minors programs', details)
          this.$store.dispatch(
            "travellersAndTrips/unaccompaniedMinorAirlineDetails",
            details
          );
        });

      // Get travel policy attributes
      this.$app
        .huddleLabsServerCall("profile/travel-policy-attributes", null)
        .then((result) => {
          let details = result.data;
          // console.log('travel-policy-attributes', details)
          this.$store.dispatch(
            "travelPolicy/addTravelPolicyAttributes",
            details
          );
        });
    },
    formatTickets(tickets) {
      var airlineCodes = [];
      var ticket;
      if (tickets) {
        for (ticket of tickets) {
          if (!airlineCodes.includes(ticket.airlineCode)) {
            airlineCodes.push(ticket.airlineCode);
          }
        }
      }
      return {
        airlines: airlineCodes,
        tickets: tickets,
      };
    },
    // ---- Auth0 PKCE Login ----

    loginWithAuth0() {
      this.startAuth0LoginAuthorize({});
    },

    loginWithEmailCode() {
      this.startAuth0LoginAuthorize({
        prompt: 'login',
        connection: this.$appConfig.auth0PasswordlessConnection || 'email',
      });
    },

    signUpWithGantId() {
      this.startAuth0LoginAuthorize({ screenHint: 'signup' });
    },

    startAuth0LoginAuthorize({ prompt, connection, screenHint }) {
      const domain      = this.$appConfig.auth0Domain;
      const clientId    = this.$appConfig.auth0ClientId;
      const audience    = this.$appConfig.auth0Audience;
      const callbackUrl = this.$appConfig.auth0LoginCallbackUrl;

      if (!domain || !clientId || !callbackUrl) {
        this.auth0Error = 'Auth0 is not configured. Please contact support.';
        return;
      }

      const codeVerifier = this.generateCodeVerifier();
      sessionStorage.setItem('auth0_login_code_verifier', codeVerifier);

      this.generateCodeChallenge(codeVerifier).then((codeChallenge) => {
        const state = Math.random().toString(36).substring(2);
        sessionStorage.setItem('auth0_login_state', state);

        const params = new URLSearchParams({
          response_type:         'code',
          client_id:             clientId,
          redirect_uri:          callbackUrl,
          scope:                 'openid profile email',
          ...(audience ? { audience } : {}),
          ...(this.email ? { login_hint: this.email } : {}),
          ...(prompt ? { prompt } : {}),
          ...(connection ? { connection } : {}),
          ...(screenHint ? { screen_hint: screenHint } : {}),
          code_challenge:        codeChallenge,
          code_challenge_method: 'S256',
          state,
        });

        window.location.href = `https://${domain}/authorize?${params.toString()}`;
      });
    },

    async handleAuth0LoginCallback() {
      this.loading = true;

      const code         = this.$route.query.code;
      const codeVerifier = sessionStorage.getItem('auth0_login_code_verifier');
      const domain       = this.$appConfig.auth0Domain;
      const clientId     = this.$appConfig.auth0ClientId;
      const callbackUrl  = this.$appConfig.auth0LoginCallbackUrl;

      if (!code || !codeVerifier) {
        this.loading    = false;
        this.auth0Error = 'Auth0 callback is invalid. Please try again.';
        return;
      }

      try {
        // Exchange authorization code for tokens
        const tokenResponse = await fetch(`https://${domain}/oauth/token`, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            grant_type:    'authorization_code',
            client_id:     clientId,
            code,
            code_verifier: codeVerifier,
            redirect_uri:  callbackUrl,
          }),
        });

        const tokens = await tokenResponse.json();

        if (!tokenResponse.ok || !tokens.id_token) {
          throw new Error(tokens.error_description || 'Token exchange failed.');
        }

        // Extract email from id_token to look up the Salesforce contact
        const email = this.decodeJwtEmail(tokens.id_token);
        if (!email) {
          throw new Error('Could not extract email from Auth0 token.');
        }

        // Look up the Salesforce contactId by email
        const contactResult = await this.$app.huddleLabsServerCall('profile/find-contact-by-email', { email });
        const contactId     = contactResult && contactResult.contactId;

        if (!contactId) {
          throw new Error('No matching travel profile found for this account.');
        }

        // Establish local session — satisfies router.beforeEach auth guard
        const expireTime = new Date().getTime() + this.$appConfig.routerTimer;
        localStorage.setItem('loginExpireTime', expireTime);

        // Load the full travel profile and hydrate the Vuex store
        const profileResult = await this.$app.huddleLabsServerCall('profile/travel-profile', {
          contactId,
          includeRelated: [
            'travelerPrograms',
            'paymentMethods',
            'unusedTickets',
            'travelPolicy',
            'preferredVendors',
            'tripcircuitConfiguration',
            'accountNotes',
          ],
        });

        if (profileResult && profileResult.data) {
          this.$store.dispatch('travellersAndTrips/addProfile', profileResult.data);
          this.$store.commit('travellersAndTrips/SET_TRAVELLER_PROFILE', profileResult.data);

          if (profileResult.data.accountNotes) {
            this.$store.dispatch('travellersAndTrips/setAccountNotes', profileResult.data.accountNotes);
          }
        }

        // Initialise travellers state (mirrors ok())
        this.$store.commit('travellersAndTrips/EDIT_TRAVELLERS', {
          tripType: 'business',
          bookFor:  'user',
          others:   [],
          set:      true,
          business: true,
          self:     true,
        });

        // Load shared resources (vendors, options, airports, etc.) — mirrors ok()
        this.getCodeConverter();

        // Clean up PKCE session data
        sessionStorage.removeItem('auth0_login_code_verifier');
        sessionStorage.removeItem('auth0_login_state');

        // Navigate to the home page
        this.$router.push('/home');
      } catch (err) {
        this.loading    = false;
        this.auth0Error = err.message || 'Auth0 login failed. Please try again.';
      }
    },

    // ---- PKCE helpers ----

    generateCodeVerifier() {
      const array = new Uint8Array(32);
      window.crypto.getRandomValues(array);
      return Array.from(array, (b) => ('0' + b.toString(16)).slice(-2)).join('');
    },

    async generateCodeChallenge(verifier) {
      const encoder = new TextEncoder();
      const data    = encoder.encode(verifier);
      const digest  = await window.crypto.subtle.digest('SHA-256', data);
      return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
    },

    decodeJwtEmail(token) {
      try {
        const payload = token.split('.')[1];
        const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        return decoded.email || null;
      } catch (_) {
        return null;
      }
    },

    // ---- End Auth0 ----

    chromeExtensionLogin() {
      /* global chrome */
      const isInstalled = document.documentElement.getAttribute(
        "extension-installed"
      );
      const editorExtensionId = "adokehipbaicohfnliedojaneclanbki";
      if (isInstalled) {
        chrome.runtime.sendMessage(
          editorExtensionId,
          {
            message: "Login successful",
            contactId: this.$globals.profile.id,
            username: this.$globals.profile.email,
            travelPolicyId: this.$globals.profile.travelPolicyId,
          },
          function(response) {
            //
            return true;
          }
        );
      }
    },
  },
  created() {
    // Handle Auth0 PKCE callback — ?code= means Auth0 redirected back here
    if (this.$route.query.code) {
      this.handleAuth0LoginCallback();
    }
  },
  mounted() {
    this.$app.logout();

    // Check for token in the URL parameter and convert to usable access_token
    var ssoToken = this.$route.query.token;
    if (ssoToken) {
      // console.log('token', ssoToken);

      // Set the secret key/salt to remove from the start of the token
      var tokenSalt = "ehENoUSO";

      // base64_decode the token
      var decoded = atob(ssoToken);

      // Remove the secret key/salt to leave only the real access token
      var accessToken = decoded.replace(tokenSalt, "");

      // Check if the access token is valid
      this.checkAccessToken(accessToken);
    }
    // this.getCodeConverter()
  },
};
</script>

<style scoped>

.message-center {
  display: flex;
  justify-content: center; 
  align-items: center; 
  width: 100%;
}
.image {
  padding: 10px;
}

.image img {
  width: 230px;
  max-width: 100%;
  display: block;
  margin: auto;
}

.trip {
  color: #292c58;
  font-family: Krungthep;
  font-size: 50px;
}

.circuit {
  color: #00aa9c;
  font-family: Krungthep;
  font-size: 50px;
}

.text-center {
  text-align: center;
}

.centered {
  margin: auto;
}

.field {
  border-radius: 5px;
}

.wdt {
  width: 500px;
  margin: auto;
  /* background-color: #F5F0E1; */
}

.register {
  background-color: #ddd;
  /* background-color: #F5F0E1; */
  border-radius: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.conditions {
  font-size: 13px;
  color: #292c58;
}

.btn {
  background-color: #292c58;
}

.auth0-divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #999;
  font-size: 13px;
  margin: 12px 0;
}
.auth0-divider::before,
.auth0-divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #ddd;
}
.auth0-divider span {
  padding: 0 10px;
}

.auth0-btn {
  
  color: #292c58 !important;
}

.login-wrap {
  width: 500px;
  max-width: 100%;
  margin: auto;
}

.login-columns .column {
  display: flex;
}

.login-columns .box {
  width: 100%;
}

.legacy-box,
.gantid-box,
.gantid-panel {
  border-radius: 5px;
}

.gantid-panel {
  width: 500px;
  max-width: 100%;
  margin: auto;
}

.gantid-box {
  position: relative;
  /* border: 2px solid #00aa9c; */
}

.gantid-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: #00aa9c;
  color: #fff;
  border-radius: 10px;
  font-size: 11px;
  padding: 2px 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.column-title {
  color: #292c58;
  font-size: 22px;
  font-weight: 600;
}

.column-subtitle,
.gantid-subtitle {
  color: #666;
  font-size: 14px;
  margin-top: 4px;
}

.gantid-title {
  color: #292c58;
  font-size: 22px;
  font-weight: 600;
}

.gantid-benefits {
  margin-top: 14px;
  font-size: 14px;
  color: #292c58;
}

.gantid-benefits li {
  list-style: disc;
  margin-left: 18px;
  margin-bottom: 6px;
}

.gantid-notice {
  font-size: 12px;
  color: #888;
  text-align: center;
}

.gantid-notice a {
  cursor: pointer;
  white-space: nowrap;
}

.option-label {
  display: block;
  font-size: 16px;
  font-weight: 600;
}

.option-help {
  display: block;
  font-size: 12px;
  opacity: 0.8;
}

.gantid-panel .button {
  height: auto;
  padding-top: 12px;
  padding-bottom: 12px;
}

.gantid-panel a {
  cursor: pointer;
}

.shdw {
  box-shadow: 0 2px 4px 0 rgba(245, 240, 225, 0.8),
    0 6px 20px 0 rgba(245, 240, 225, 0.8);
  border-radius: 5px;
}

.fade {
  opacity: 0.5;
  transition: opacity 0.05s ease-in-out;
  -moz-transition: opacity 0.05s ease-in-out;
  -webkit-transition: opacity 0.05s ease-in-out;
}

.fade:hover {
  opacity: 1;
}

@media screen and (max-width: 1023px) {
  .wdt {
    width: 100%;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}

@media screen and (min-width: 1024px) {
  .wdt {
    width: 500px;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}
</style>
